import ServiceCRUD from '../../../services/ServiceCRUDSCALE';

class TimeShiftSupervisor extends ServiceCRUD {
  constructor() {
    super('/api/time-shift/supervisor');
  }
}

export default new TimeShiftSupervisor();
